// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"cf06da11","52":"e83dce52","102":"53dc59e1","189":"2754f383","331":"cd5f0583","356":"09d61775","357":"3324a199","446":"22d9e782","852":"e01f4cb5","857":"2f042012","892":"a1f9911f","982":"e137dbab"}[chunkId] + ".chunk.js";
};